// Base Imports
import { useState, useEffect } from 'react'

// Package Imports
import { Menu } from '@headlessui/react'
import Link from 'next/link'

import { recordGA4Event } from '@components/services/analytics/ga4'
import LoginModalRouter from './LoginModalRouter'
import useDataSubmit from '@commerce/utils/use-data-submit'
import { UserIcon } from '@components/icons'
declare const window: any

export default function Account({
  config,
  title,
  deviceInfo,
  previousPath,
}: any) {
  const [hydrationState, setHydrationState] = useState<any>(false)
  const { isMobile, isIPadorTablet } = deviceInfo
  const { state: submitState, dispatch: submitDispatch } = useDataSubmit()

  let deviceCheck = ''

  if (isMobile || isIPadorTablet) {
    deviceCheck = 'Mobile'
  } else {
    deviceCheck = 'Desktop'
  }

  const userProfileGAEvent = () => {
    if (typeof window !== 'undefined') {
      recordGA4Event(window, 'user_profile', {
        previous_page: previousPath,
      })
    }
  }

  useEffect(() => {
    setHydrationState(true)
  }, [])

  return (
    <>
      <Menu
        as="div"
        className="relative justify-center inline-block w-10 px-1 text-left sm:w-12 min-w-50"
      >
        {hydrationState && (
          <Menu.Button
            className="flex flex-col items-center justify-center grid-cols-1 mx-auto text-center group align-center"
            aria-label="My Account"
          >
            <Link legacyBehavior href="/my-account" passHref>
              <a className="" onClick={userProfileGAEvent}>
                {/* <i className="sprite-icon sprite-user" /> */}
                <UserIcon />
              </a>
            </Link>
          </Menu.Button>
        )}
      </Menu>
      <LoginModalRouter
        submitState={submitState}
        submitDispatch={submitDispatch}
        deviceInfo={deviceInfo}
      />
    </>
  )
}
